/**
 * @type {Object}
 * @property {array}  data  Item data
 */
const initialState = {
    canceledOrders: [],
    canceledOrderItems: [],
    canceledOAndMissionOrderItems: []
};

/**
 * 
 * @param {Object} state    Initial state of store 
 * @param {Object} action   action data
 * @returns {Object} newState 
 */
const reducerCanceledOrders = (state = initialState, action) => {
    const newState = { ...state }
    switch (action.type) {
        case 'FETCH_CANCELED_ORDERS':
            var { data } = action;
            newState.canceledOrders = data;
            break;

        case 'FETCH_CANCELED_ORDER_ITEMS':
            var { data } = action;
            newState.canceledOrderItems = data;
            break;
        case 'FETCH_CANCELED_ORDER_AND_MISSION_ORDER_ITEMS':
            var { data } = action;
            newState.canceledOAndMissionOrderItems = data;
            break;

        default:
            break;
    }
    return newState;
}

export default reducerCanceledOrders;